import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { CssBaseline } from '@mui/material';
import './print.css'; // Estilos para impresión

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CssBaseline />   {/* 👈 Esto resetea los márgenes por defecto */}
    <App />
  </React.StrictMode>
);